/* =============================================================================
 * CONSTANTES DEL SITIO PARA COMPARTIR Y PARA BUSCADORES.
 * -----------------------------------------------------------------------------
 * Este modulo NO puede importar nada del DOM: lo consume el plugin de Vite
 * (Node, durante el build) para escribir el `<head>` de las SEIS paginas ANTES
 * de que exista un navegador. Por eso vive fuera de `components/` y por eso
 * `tsconfig.node.json` tambien lo typechequea (lib ES2023, sin DOM).
 *
 * POR QUE ESTO ES SUBSTRATO Y NO DE CADA PAGINA:
 * los rastreadores de WhatsApp, Instagram, Telegram y X NO EJECUTAN JavaScript.
 * Una etiqueta puesta por React al montar el componente NO EXISTE para ellos:
 * leen el HTML crudo que devuelve el servidor y se van. Si esto viviera en las
 * paginas, la vista previa saldria vacia igual. Ver `docs/PAGE_CONTRACT.md`.
 * ========================================================================== */

/** Origen canonico. Sin barra final: las rutas ya la traen o no la necesitan. */
export const SITE_ORIGIN = 'https://eventoazrahel.com';

/** `og:site_name`. Es el nombre del SITIO, no el de la pagina. */
export const SITE_NAME = 'Gira 2027 · Nueva Humanidad Galáctica';

/** `og:locale` usa guion bajo (es_ES), no guion medio. `<html lang>` usa `es`. */
export const SITE_LOCALE = 'es_ES';
export const SITE_LANG = 'es';

/** Quien imparte la gira. Dato del brief, no una atribucion inventada. */
export const PERFORMER_NAME = 'Azrahel del Mayor';

/**
 * ADR-002: la marca es AΩGR (alfa-omega-G-R), que se lee "ÁGORA". La omega es
 * U+03A9. NUNCA las cuatro letras sin omega, tampoco dentro de una etiqueta
 * meta ni de un JSON-LD: una vista previa de WhatsApp es tan publica como el h1.
 */
export const ORGANIZER_NAME = 'Escuela Pleyadiana AΩGR';

/** Titulo de la 404. No es una ruta indexable: no lleva ficha propia. */
export const NOT_FOUND_TITLE = `Página no encontrada · ${SITE_NAME}`;

/** Convierte una ruta interna ('/bogota') en URL absoluta y canonica. */
export function absoluteUrl(path: string): string {
  return path === '/' ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`;
}
